export const HalloweenDivider = ({ color = "bg-blood" }) => {
  const segments = 22;
  const bottom = Array.from({ length: segments + 1 }, (_, i) => {
    const x = (i / segments) * 100;
    const y = i % 2 === 0 ? 100 : 52;
    return `${x}% ${y}%`;
  }).reverse();
  const clipPath = `polygon(0% 0%, 100% 0%, ${bottom.join(", ")})`;

  return (
    <div
      className={`relative w-full h-6 sm:h-8 ${color}`}
      style={{ clipPath }}
      data-testid="halloween-drip-divider"
    />
  );
};
